import type { PrintResponse } from '@/components/modals/Print/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class PrintHttpService extends HttpService {
  print<T>(options: T): HttpClientResponse<PrintResponse> {
    return this.httpClient.post('tarifuebersicht/drucken', {
      data: options,
    });
  }

  generateContractDocuments<T>(options: T): HttpClientResponse<PrintResponse> {
    return this.httpClient.post('antrag/dokumente', {
      data: options,
    });
  }
}
